import { render, staticRenderFns } from "./export-talk-details.vue?vue&type=template&id=25d9c7a4&scoped=true&"
import script from "./export-talk-details.vue?vue&type=script&lang=js&"
export * from "./export-talk-details.vue?vue&type=script&lang=js&"
import style0 from "./export-talk-details.vue?vue&type=style&index=0&id=25d9c7a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d9c7a4",
  null
  
)

export default component.exports